/**
 * SAIT-135: блок подписки — в подвале (variant="footer") и в конце статьи блога и новости
 * (variant="article", карточка в тексте). Слева заголовок и подпись, справа кнопка: она
 * загружает группу vpl.tas.newsletter и открывает окно с формой (NewsletterDialogHost в подвале).
 * Автоматического всплывающего окна нет; источник подписки (source) уходит в журнал согласий.
 */
import { newsletterState, openNewsletter } from './newsletter-state';
import './newsletter-host.css';

const template = `
    <section class="tnl-host" :class="'tnl-host--' + variant" aria-label="Подписка на новости и акции">
        <div class="tnl-host__copy">
            <h2 class="tnl-host__title">Подписка на новости и акции</h2>
            <p class="tnl-host__text">Специальные предложения, новинки оборудования и полезные материалы.</p>
        </div>
        <div class="tnl-host__action">
            <button type="button" class="btn btn--green tnl-host__button" :disabled="newsletterState.pending" :aria-busy="newsletterState.pending"
                @click="openNewsletter(source)">{{ newsletterState.pending && newsletterState.source === source ? 'Загружаем…' : 'Подписаться' }}</button>
            <p v-if="newsletterState.error && newsletterState.source === source" class="tnl-host__status" role="alert">{{ newsletterState.error }}</p>
        </div>
    </section>
`;

export const NewsletterHost = {
    props: {
        source: { type: String, required: true },
        variant: { type: String, default: 'footer' },
    },
    setup() {
        return { newsletterState, openNewsletter };
    },
    template,
};
